import styled from 'styled-components';

export const LinkedDueFieldsWrapper = styled.div`
  display: flex;
  & > div {
    flex: 1;

    :nth-child(2) {
      flex: 0;
      margin: 7px 6px 0;
    }
  }
`;
